import React from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';

import LazyLoader from 'imports/LazyLoader.js';

// Mounts the /mod/external-keys admin diagnostic page onto its shell container.
$(function() {
	const mount = $('#external-keys');
	if(!mount.length) {
		return;
	}

	LazyLoader.externalKeyStatus()
		.then((ExternalKeyStatus) => {
			renderIntoContainer(<ExternalKeyStatus />, mount[0]);
		});
});
